import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import t from "../translate"
import LeftMenu from "../leftmenu"
import apiCall from "../api"

const GenerateRegistrationLink = props => {

  const auth = useSelector(state => state.auth)

  const [interventionId, setInterventionId] = useState(0)
  const [links, setLinks] = useState([])
  const [errorMessage, setErrorMessage] = useState("")
  const [successMessage, setSuccessMessage] = useState("")
  const [copiedToken, setCopiedToken] = useState("")

  useEffect(() => {
    loadLinks()
  }, [])

  function loadLinks() {
    apiCall({
      action: "get_registration_links",
      token: auth.token,
      data: {}
    }).then(resp => {
      if (resp && resp.links) {
        setLinks(resp.links)
      }
    })
  }

  function generateLink() {
    setErrorMessage("")
    setSuccessMessage("")
    apiCall({
      action: "generate_registration_link",
      token: auth.token,
      data: {
        intervention_id: interventionId > 0 ? interventionId : null
      }
    }).then(resp => {
      if (resp && resp.generate_registration_link) {
        setSuccessMessage(resp.url)
        loadLinks()
      } else if (resp && resp.msg) {
        setErrorMessage(resp.msg)
      }
    })
  }

  function copyToClipboard(url, token) {
    navigator.clipboard.writeText(url).then(() => {
      setCopiedToken(token)
      setTimeout(() => setCopiedToken(""), 2000)
    })
  }

  function deactivateLink(linkId) {
    apiCall({
      action: "generate_registration_link",
      token: auth.token,
      data: { deactivate_id: linkId }
    }).then(() => {
      loadLinks()
    })
  }

  return (
    <div className="transWrapper">
      <div className="container dashboard admin">
        <LeftMenu />

        <div>
          <h2>{t("Registratielinks genereren")}</h2>
          <p>{t("Genereer een link waarmee studenten zich kunnen registreren. Studenten die via deze link binnenkomen worden automatisch aan u gekoppeld als coach.")}</p>

          {errorMessage.length > 0 ?
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-circle"></i> &nbsp;
              <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
            </div>
            : <></>
          }

          {successMessage.length > 0 ?
            <div className="alert alert-success">
              <i className="fas fa-check-circle"></i> &nbsp;
              {t("Link gegenereerd:")} <br />
              <a href={successMessage} target="_blank" rel="noopener noreferrer">{successMessage}</a>
            </div>
            : <></>
          }

          <br />

          <select
            className="custom-select"
            style={{width: "100%"}}
            onChange={(e) => setInterventionId(parseInt(e.target.value))}
            value={interventionId}>
            <option value="0">{t("Alle programma's (student kiest zelf)")}</option>
            {
              props.interventions.map((int, index) => {
                return (
                  <option key={index} value={int.id}>{int.title}</option>
                )
              })
            }
          </select>

          <br />
          <br />

          <span className="btn btn-primary" onClick={generateLink}>
            <i className="fas fa-link"></i> &nbsp;
            {t("Genereer link")}
          </span>

          <br />
          <br />
          <hr />

          <h4>{t("Actieve links")}</h4>
          {links.length === 0 ?
            <p className="text-muted">{t("U heeft nog geen actieve registratielinks.")}</p>
            :
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{t("Link")}</th>
                  <th>{t("Programma")}</th>
                  <th>{t("Aangemaakt")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {links.map((link, index) => (
                  <tr key={index}>
                    <td style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                      <a href={link.url} target="_blank" rel="noopener noreferrer" title={link.url}>
                        {link.url}
                      </a>
                    </td>
                    <td>{link.intervention_title || t("Alle programma's")}</td>
                    <td>{new Date(link.created_at).toLocaleDateString()}</td>
                    <td>
                      <span
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => copyToClipboard(link.url, link.token)}
                        title={t("Kopieer link")}
                      >
                        {copiedToken === link.token ?
                          <><i className="fas fa-check"></i> {t("Gekopieerd")}</>
                          :
                          <><i className="fas fa-copy"></i> {t("Kopieer")}</>
                        }
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          }
        </div>
      </div>
    </div>
  )
}

export default GenerateRegistrationLink;
